import * as React from 'react';
import Checkbox from '@material-ui/core/Checkbox';

interface CheckboxsProps {
    name: string;
    value: any;
    handleToUpdate: Function;
}

export const Checkboxs: React.FC<CheckboxsProps> = (props: CheckboxsProps) => {
    const {
        name, value, handleToUpdate
    } = props;
    return (
        <div>
            <Checkbox
                onChange={(event) => {
                    handleToUpdate(name, event.target.checked)
                }}
                value={value}
                name={name}
            />
        </div>
    )
}

export default Checkboxs